<app-header-task-view
    [label]="getHeadline()">
</app-header-task-view>

<app-completed-by-task-view
    *ngIf="_task?.state === 'COMPLETED'"
    [task]="_task">
</app-completed-by-task-view>

<app-assignment-task-view
    *ngIf="_task?.state !== 'COMPLETED'"
    [task]="_task">
</app-assignment-task-view>

<app-contact-task-view
    [label]="'rentModule.nexcoreOperatedRentalTaskViewComponent.contactLabel' | translate"
    [contact]="_task?.order?.customer">
</app-contact-task-view>

<app-order-task-view
    [order]="_task?.order">
</app-order-task-view>

<app-location-task-view
    [location]="_task?.order?.location">
</app-location-task-view>

<app-protocol-view
    *ngIf="_task?.protocol"
    [showAssignment]="false"
    [protocol]="_task?.protocol">
</app-protocol-view>
<div class="border-b"></div>

<app-complete-button-task-view
    [task]="_task"
    [notCompletedLabel]="'rentModule.nexcoreOperatedRentalTaskViewComponent.notCompletedLabel' | translate"
    [canComplete]="false"
></app-complete-button-task-view>